<app-menu-common url="sales"></app-menu-common>

<div class="rp-page">

  <div class="head-card">
    <a class="back" routerLink="/sales/rental-products"><mat-icon>arrow_back</mat-icon><span>Articles de location</span></a>
    @if (product) {
      <div class="head-title">
        <mat-icon class="toolbar-icon">bed</mat-icon>
        <a class="p-link" [routerLink]="['/sales/product', product.id]" matTooltip="Ouvrir la fiche article">
          <span class="p-name">{{ product.name || '—' }}</span>
          <span class="p-id">#{{ product.id }}</span>
        </a>
      </div>
      <div class="head-facts">
        @if (product.partnbloc) { <span><b>Réf. int.</b> {{ product.partnbloc }}</span> }
        @if (product.partnbsup) { <span><b>Réf. fourn.</b> {{ product.partnbsup }}</span> }
        @if (product.partnbman) { <span><b>Réf. fab.</b> {{ product.partnbman }}</span> }
        <span [class.warn]="!product.is_sold" [matTooltip]="product.is_sold ? '' : 'Un article non vendable n\'est pas proposé à la saisie F3'">
          <b>Vendable</b> {{ product.is_sold ? 'oui' : 'non' }}
        </span>
        <a class="link" [routerLink]="['/sales/product', product.id]" target="_blank" matTooltip="Fiche produit complète (nom, prix, conditionnements), dans un nouvel onglet">
          Fiche produit<mat-icon>open_in_new</mat-icon>
        </a>
      </div>
    }
  </div>

  @if (loading && !product) {
    <div class="state-box"><mat-spinner diameter="28"></mat-spinner><span>Chargement de l'article…</span></div>
  } @else if (error && !product) {
    <div class="state-box error"><mat-icon>error_outline</mat-icon><span>{{ error }}</span></div>
  } @else {

    <div class="tabs-bar">
      <span class="tabs-label" matTooltip="Les contrats actifs sont proposés dans cet ordre à la saisie F3">Contrats de location</span>
      @for (t of tabs; track $index; let i = $index) {
        <button type="button" class="tab" [class.active]="i === current" [class.inactive]="!t.card.is_active" (click)="select(i)" [title]="tabLabel(t)">
          <span class="seq">{{ t.seq }}</span>
          <span class="tab-name">{{ tabLabel(t) }}</span>
          @if ((t.source.products?.length ?? 0) > 1) { <span class="chip shared">×{{ t.source.products?.length }}</span> }
          @if (!t.card.id) { <span class="chip new">nouveau</span> }
          @if (isDirty(t) && t.card.id) { <span class="dirty-dot" matTooltip="Modifiée, non enregistrée"></span> }
        </button>
      }
      <span class="spacer"></span>
      <button type="button" class="btn-inline btn-create" (click)="newCard()" matTooltip="Créer un contrat de location pour cet article : à l'enregistrement il entre au catalogue, rattaché à l'article">
        <mat-icon>add</mat-icon><span>Nouveau contrat</span>
      </button>
      <button type="button" class="btn-inline btn-ghost" [class.on]="attachOpen" (click)="toggleAttach()" matTooltip="Rattacher à cet article un contrat de location déjà au catalogue">
        <mat-icon>link</mat-icon><span>Contrat existant</span>
      </button>
    </div>

    @if (attachOpen) {
      <div class="attach-panel">
        <div class="attach-head">
          <mat-icon>link</mat-icon><span>Rattacher un contrat de location du catalogue</span>
          <input class="field attach-search" [(ngModel)]="attachText" placeholder="Nom, n° de contrat ou code LPP" autofocus>
          <button type="button" class="btn-inline btn-ghost" (click)="attachOpen = false" aria-label="Fermer"><mat-icon>close</mat-icon></button>
        </div>
        @if (attachError) { <div class="banner error"><mat-icon>error_outline</mat-icon><span>{{ attachError }}</span></div> }
        @if (attachLoading) {
          <div class="state-box small"><mat-spinner diameter="22"></mat-spinner><span>Lecture du catalogue…</span></div>
        } @else {
          <div class="attach-list">
            @for (c of attachable; track c.id) {
              <div class="attach-row" [class.inactive]="!c.is_active">
                <span class="mono faint">{{ c.id }}</span>
                <span class="attach-name" [title]="c.name">{{ c.name }}</span>
                <span class="faint">{{ c.tiered_pricing[0]?.fse_lpp ?? '' }}</span>
                <button type="button" class="btn-inline btn-create small" (click)="attach(c)"><mat-icon>add_link</mat-icon><span>Rattacher</span></button>
              </div>
            } @empty {
              <div class="state-box small"><span>Aucun contrat ne répond.</span></div>
            }
          </div>
        }
      </div>
    }

    @if (!tabs.length) {
      <div class="state-box">
        <mat-icon class="empty-icon">post_add</mat-icon>
        <span>Cet article ne porte encore aucun contrat de location : il n'est pas proposé à la saisie F3.</span>
        <span class="faint">Créez-lui un contrat de location, ou rattachez un contrat du catalogue.</span>
      </div>
    }

    @if (tab; as t) {
      @if ((t.source.products?.length ?? 0) > 1) {
        <div class="banner shared">
          <mat-icon>warning</mat-icon>
          <span>
            Contrat partagé par <b>{{ t.source.products?.length }} articles</b> : l'enregistrer les change tous.
            <span class="shared-list">
              @for (p of t.source.products; track p.id) {
                @if (p.id === productId) { <span class="me">{{ p.name }}</span> } @else { <a [routerLink]="['/sales/rental-product', p.id, t.card.id]">{{ p.name }}</a> }
              }
            </span>
          </span>
          <button type="button" class="btn-inline btn-ghost" (click)="duplicate(t)" [matTooltip]="DUPLICATE_HINT" matTooltipClass="tooltip-multiline">
            <mat-icon>content_copy</mat-icon><span>Dupliquer pour cet article seul</span>
          </button>
        </div>
      }
      @if (t.replaces) {
        <div class="banner info"><mat-icon>swap_horiz</mat-icon><span>Copie du contrat n° {{ t.replaces }} : à l'enregistrement il le remplace sur cet article, les autres articles gardent l'original.</span></div>
      }
      @if (t.source.billing_error) {
        <div class="banner error"><mat-icon>error_outline</mat-icon><span>{{ t.source.billing_error }} — toute ligne qui copie ce contrat est bloquée au passage. Enregistrer réécrit des règles lisibles.</span></div>
      }

      <div class="editor-grid">

        <div class="col">
          <section class="panel">
            <h3><mat-icon>badge</mat-icon>Contrat de location</h3>
            <label class="fld wide">
              <span class="lbl">Nom</span>
              <input class="field" [(ngModel)]="t.card.name" placeholder="Nom du contrat, tel que proposé en F3">
            </label>
            <div class="row">
              <label class="fld">
                <span class="lbl">Période</span>
                <select class="field select" [(ngModel)]="t.card.period">
                  @for (p of periods; track p.id) { <option [ngValue]="p.id">{{ p.name }}</option> }
                </select>
              </label>
              <label class="fld">
                <span class="lbl" matTooltip="TVA reprise sur la ligne à la saisie F3 ; le moteur facture ensuite avec la TVA de la ligne">TVA</span>
                <select class="field select" [(ngModel)]="t.card.vat">
                  @for (x of taxOptions(t); track x.id) { <option [ngValue]="x.id">{{ x.rate | number: '1.1-2' }} %</option> }
                </select>
              </label>
              <label class="fld">
                <span class="lbl" matTooltip="Ordre du contrat parmi ceux de l'article à la saisie F3">Rang F3</span>
                <input class="field num short" type="number" min="1" [(ngModel)]="t.seq">
              </label>
            </div>
            <div class="seg-block">
              <span class="lbl">État</span>
              <div class="seg">
                <button type="button" [class.on]="t.card.is_active" (click)="t.card.is_active = true">Actif</button>
                <button type="button" [class.on]="!t.card.is_active" (click)="t.card.is_active = false">Inactif</button>
              </div>
              <span class="hint">{{ t.card.is_active ? 'Proposé dans la liste des contrats quand on saisit une location (F3).' : 'N\'est plus proposé à la saisie d\'une location (F3) ; les dossiers déjà saisis ne changent pas.' }}</span>
            </div>
            @if (otherData(t).length) {
              <div class="other-data" matTooltip="Clés du contrat qu'aucun code ne lit ; elles sont conservées telles quelles">
                <span class="lbl">Autres données</span>
                @for (d of otherData(t); track d[0]) { <span class="kv"><b>{{ d[0] }}</b> {{ d[1] }}</span> }
              </div>
            }
            <p class="note">Les dossiers déjà saisis gardent leur copie du contrat de location : le modifier ne change que les prochaines saisies F3.</p>
          </section>

          <section class="panel">
            <h3><mat-icon>add_shopping_cart</mat-icon>Ventes associées</h3>
            <p class="note">Ajoutées comme lignes vendues du dossier à la livraison ou à la reprise du matériel.</p>
            @if (t.card.linked_products.length) {
              <div class="lp-table">
                <div class="lp-row head"><span>Produit</span><span class="num">Qté</span><span>Quand</span><span></span></div>
                @for (l of t.card.linked_products; track $index; let i = $index) {
                  <div class="lp-row">
                    <a class="lp-name" [routerLink]="['/sales/product', l.product_id]" target="_blank" [title]="linkedNames.get(l.product_id) ?? ''">
                      <span class="mono faint">{{ l.product_id }}</span> {{ linkedNames.get(l.product_id) || 'Produit ' + l.product_id }}
                    </a>
                    <input class="field num tiny" type="number" min="0" step="any" [(ngModel)]="l.quantity">
                    <select class="field select" [ngModel]="triggerOf(l)" (ngModelChange)="setTrigger(l, $event)">
                      <option value="delivery">À la livraison</option>
                      <option value="return">À la reprise</option>
                      @if (triggerOf(l) === 'recurring') { <option value="recurring" disabled>Récurrent (non appliqué)</option> }
                    </select>
                    <button type="button" class="icon-btn" (click)="removeLinked(t, i)" aria-label="Retirer"><mat-icon>delete_outline</mat-icon></button>
                  </div>
                }
              </div>
            }
            <div class="lp-add">
              <app-search-product width="100%" placeholder="Ajouter un produit (livraison, sangle…)" (selectProductEmitter)="addLinked(t, $event)"></app-search-product>
            </div>
          </section>
        </div>

        <section class="panel">
          <h3><mat-icon>euro</mat-icon>Prix</h3>
          <div class="seg-block">
            <span class="lbl">Source du prix</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.price_source === 'CARD'" (click)="setRule(t, 'price_source', 'CARD')">Prix du contrat</button>
              <button type="button" [class.on]="t.billing.price_source === 'LPP_TARIF'" (click)="setRule(t, 'price_source', 'LPP_TARIF')">Tarif LPP</button>
              <button type="button" [class.on]="t.billing.price_source === 'LPP_PLV'" (click)="setRule(t, 'price_source', 'LPP_PLV')">PLV LPP</button>
            </div>
            <span class="hint">{{ hints['price_source.' + t.billing.price_source] }}</span>
          </div>

          @for (g of t.grids; track $index) {
            <div class="grid-block" [class.current]="g.from === currentGridFrom(t)">
              <div class="grid-head">
                @if (g.from) {
                  <span>Grille à partir du</span>
                  <input class="field date" type="date" [(ngModel)]="g.from" (change)="sortGrids(t)">
                  <button type="button" class="icon-btn" (click)="removeGrid(t, g)" matTooltip="Supprimer cette grille datée"><mat-icon>delete_outline</mat-icon></button>
                } @else {
                  <span>Grille sans date</span>
                }
                @if (g.from === currentGridFrom(t)) { <span class="chip secu-ok">en vigueur</span> }
              </div>
              <div class="tier-table">
                <div class="tier-row head">
                  <span matTooltip="Rang de la première période où ce palier s'applique">Dès la période</span>
                  <span class="num">Prix HT</span>
                  <span class="num">TTC</span>
                  <span>Code LPP</span>
                  <span class="num" matTooltip="Tarif de responsabilité TTC en vigueur aujourd'hui, lu dans la nomenclature">Tarif LPP</span>
                  <span></span>
                </div>
                @for (x of g.tiers; track $index; let i = $index) {
                  <div class="tier-row">
                    <input class="field num" type="number" min="1" step="1" [(ngModel)]="x.starting_period">
                    <input class="field num" type="number" min="0" step="0.01" [(ngModel)]="x.uprice_taxx" [disabled]="isLppPrice(t)"
                      [matTooltip]="isLppPrice(t) ? 'Ignoré : le prix vient du code LPP' : ''">
                    <span class="num calc">@if (!isLppPrice(t) && ttc(t, x.uprice_taxx) !== null) { {{ ttc(t, x.uprice_taxx) | number: '1.2-2' }} }</span>
                    <input class="field mono" [(ngModel)]="x.fse_lpp" placeholder="—" maxlength="13">
                    <span class="num calc" [class.missing]="isLppPrice(t) && x.fse_lpp && x.tarifref == null"
                      [matTooltip]="x.fse_lpp && x.tarifref == null ? 'Tarif inconnu : code sans ligne en vigueur, ou pas encore enregistré' : ''">
                      @if (x.tarifref != null) { {{ x.tarifref | number: '1.2-2' }} } @else if (x.fse_lpp) { ? }
                    </span>
                    <button type="button" class="icon-btn" (click)="removeTier(g, i)" aria-label="Supprimer le palier"><mat-icon>close</mat-icon></button>
                  </div>
                }
              </div>
              <button type="button" class="btn-link" (click)="addTier(g)"><mat-icon>add</mat-icon>Palier</button>
            </div>
          }
          <div class="grid-actions">
            <button type="button" class="btn-inline btn-ghost" (click)="addGrid(t)" matTooltip="Nouveau tarif à partir d'une date : copie de la dernière grille, à modifier">
              <mat-icon>event</mat-icon><span>Grille datée</span>
            </button>
          </div>
          <p class="note">Un palier vaut de son rang jusqu'au palier suivant. Une grille datée remplace toute la grille précédente pour les périodes qui commencent ce jour-là ou après : elle redonne tous ses paliers.</p>
        </section>

        <section class="panel">
          <h3><mat-icon>rule</mat-icon>Règles de facturation</h3>
          <div class="secu-box" [class.ok]="!faults(t).length">
            @if (!faults(t).length) {
              <mat-icon>verified</mat-icon><span><b>Conforme FSE</b> : passe les contrôles Sécu du passage.</span>
            } @else {
              <mat-icon>info</mat-icon>
              <span [matTooltip]="SECU_FAULTS_HINT" matTooltipClass="tooltip-multiline"><b>Hors FSE</b> : {{ faults(t).join(' ; ') }}.</span>
            }
            <span class="spacer"></span>
            <button type="button" class="btn-inline btn-ghost small" (click)="applyPreset(t, 'secu')" matTooltip="Pose les règles Sécu ; la clôture d'une longue pause garde sa valeur">Jeu Sécu</button>
            <button type="button" class="btn-inline btn-ghost small" (click)="applyPreset(t, 'defaults')" matTooltip="Pose les défauts du moteur">Défauts</button>
          </div>

          <div class="seg-block">
            <span class="lbl">Interruption (hospitalisation, panne)</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.interruption_rule === 'PAUSE'" (click)="setRule(t, 'interruption_rule', 'PAUSE')">Pause</button>
              <button type="button" [class.on]="t.billing.interruption_rule === 'FULL_PERIOD'" (click)="setRule(t, 'interruption_rule', 'FULL_PERIOD')">Période due</button>
              <button type="button" [class.on]="t.billing.interruption_rule === 'PRORATA'" (click)="setRule(t, 'interruption_rule', 'PRORATA')">Prorata</button>
            </div>
            <span class="hint">{{ hints['interruption_rule.' + t.billing.interruption_rule] }}</span>
          </div>

          @if (t.billing.interruption_rule === 'PAUSE') {
            <div class="seg-block">
              <span class="lbl">Clôture d'une longue interruption</span>
              <div class="row">
                <input class="field num short" type="number" min="0" step="1" placeholder="jamais" [ngModel]="t.billing.pause_close_after_days ?? ''" (ngModelChange)="setPauseClose(t, $event)">
                <span class="faint">jours</span>
              </div>
              <span class="hint">{{ hints['pause_close_after_days'] }}</span>
            </div>
          }

          <div class="seg-block">
            <span class="lbl">Fin</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.end_rule === 'FULL_PERIOD'" (click)="setRule(t, 'end_rule', 'FULL_PERIOD')">Due en entier</button>
              <button type="button" [class.on]="t.billing.end_rule === 'PRORATA'" (click)="setRule(t, 'end_rule', 'PRORATA')">Prorata</button>
            </div>
            <span class="hint">{{ hints['end_rule.' + t.billing.end_rule] }}</span>
          </div>

          <div class="seg-block">
            <span class="lbl">Jour de reprise facturé</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.return_day_billed" (click)="setRule(t, 'return_day_billed', true)">Oui</button>
              <button type="button" [class.on]="!t.billing.return_day_billed" (click)="setRule(t, 'return_day_billed', false)">Non</button>
            </div>
            <span class="hint">{{ hints['return_day_billed'] }}</span>
          </div>

          <div class="seg-block">
            <span class="lbl">Trop-facturé</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.overbilling === 'CREDIT_NOTE'" (click)="setRule(t, 'overbilling', 'CREDIT_NOTE')">Avoir</button>
              <button type="button" [class.on]="t.billing.overbilling === 'COMPENSATION'" (click)="setRule(t, 'overbilling', 'COMPENSATION')">Report</button>
            </div>
            <span class="hint">{{ hints['overbilling.' + t.billing.overbilling] }}</span>
          </div>

          <div class="seg-block">
            <span class="lbl">Début de facturation avant la livraison</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.start_before_delivery" (click)="setRule(t, 'start_before_delivery', true)">Permis</button>
              <button type="button" [class.on]="!t.billing.start_before_delivery" (click)="setRule(t, 'start_before_delivery', false)">Interdit</button>
            </div>
            <span class="hint">{{ hints['start_before_delivery'] }}</span>
          </div>

          <div class="seg-block">
            <span class="lbl">Prescription</span>
            <div class="seg">
              <button type="button" [class.on]="t.billing.prescription_required" (click)="setRule(t, 'prescription_required', true)">Exigée</button>
              <button type="button" [class.on]="!t.billing.prescription_required" (click)="setRule(t, 'prescription_required', false)">Non exigée</button>
            </div>
            <span class="hint">{{ hints['prescription_required'] }}</span>
          </div>
        </section>
      </div>

      <div class="actions-bar">
        @if (t.error) { <span class="save-error"><mat-icon>error_outline</mat-icon>{{ t.error }}</span> }
        <span class="spacer"></span>
        @if (t.card.id) {
          <button type="button" class="btn-inline btn-danger" (click)="unlink(t)" [disabled]="t.saving" matTooltip="Le contrat reste au catalogue et sur ses autres articles">
            <mat-icon>link_off</mat-icon><span>Retirer de cet article</span>
          </button>
        }
        <button type="button" class="btn-inline btn-ghost" (click)="discard(t)" [disabled]="t.saving || (!!t.card.id && !isDirty(t))">
          <mat-icon>undo</mat-icon><span>{{ t.card.id ? 'Annuler les modifications' : 'Abandonner' }}</span>
        </button>
        <button type="button" class="btn-inline btn-search" (click)="save(t)" [disabled]="t.saving || !isDirty(t)">
          <mat-icon [class.spinning]="t.saving">{{ t.saving ? 'autorenew' : 'save' }}</mat-icon>
          <span>{{ t.card.id ? 'Enregistrer le contrat' : 'Créer le contrat' }}</span>
        </button>
      </div>
    }
  }
</div>
